import React from 'react';
import List from './List';

const Bills = ({clientId,...props}) => {
    return (
        <List typeId={2} clientId={clientId} {...props}/>
    );
}

export default Bills;
